"use client";

// Sections below the first screen rise into place as they arrive. Nothing is hidden in the HTML: the
// classes go on from here, after the page has painted, and only on what is still below the fold, so
// the first screen, search engines and anyone who asked for less motion get the page as it is.
// Mark an element with data-reveal; data-reveal="2" waits two steps, for a row that arrives in turn.
import { useEffect } from "react";
import { usePathname } from "next/navigation";

const HIDDEN = ["opacity-0", "translate-y-6"];
const MOVING = ["transition-[opacity,translate]", "duration-700", "ease-out"];
const STEP_MS = 90;

export function Reveal() {
  const path = usePathname();
  useEffect(() => {
    if (!("IntersectionObserver" in window) || !window.matchMedia("(prefers-reduced-motion: no-preference)").matches) return;
    const fold = window.innerHeight;
    const els = [...document.querySelectorAll<HTMLElement>("[data-reveal]")].filter((el) => el.getBoundingClientRect().top > fold);
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (!e.isIntersecting) continue;
          io.unobserve(e.target);
          e.target.classList.remove(...HIDDEN);
        }
      },
      { rootMargin: "0px 0px -8% 0px" },
    );
    for (const el of els) {
      const step = Number(el.dataset.reveal) || 0;
      if (step) el.style.transitionDelay = `${step * STEP_MS}ms`;
      el.classList.add(...MOVING, ...HIDDEN);
      io.observe(el);
    }
    return () => {
      io.disconnect();
      for (const el of els) el.classList.remove(...HIDDEN);
    };
  }, [path]);
  return null;
}
